module.exports = __webpack_public_path__ + "static/media/YM21_3.d4e6ad18.jpg";